export const BOOKING = "BOOKING";
export const RESOURCE_WORK_HOURS = "RESOURCE_WORK_HOURS";
export const RESOURCE_HOLIDAY = "RESOURCE_HOLIDAY";
export const RESOURCE_SICK = "RESOURCE_SICK";
export const RESOURCE_BREAK = "EMPLOYEE_BREAK";
export const RESOURCE_COMPASSIONATE_LEAVE = "RESOURCE_COMPASSIONATE_LEAVE";
export const STORE_CLOSED = "STORE_CLOSED";
